<template>
  <b-modal class="customer-show-ortho-arch" id="customer-show-ortho-arch" ref="modal" :title="dialog_title" hide-footer>

    <!-- MAIN OPTIONS -->
    <div class="form-group row">
      <div class="col-md-4">
        <select v-model="arch" id="show_arch_position" class="custom-select">
          <option value="upper">Superior</option>
          <option value="lower">Inferior</option>
        </select>
        <label class="wabident-info" for="show_arch_position">Arco</label>
      </div>

      <div class="col-md-4">
        <input type="date" id="show_arch_placement_date" class="form-control" v-model="placement_date" />
        <label for="show_arch_placement_date" class="wabident-info">Fecha Colocación</label>
      </div>

      <div class="col-md-4">
        <input type="date" id="show_arch_removal_date" class="form-control" v-model="removal_date" />
        <label for="show_arch_removal_date" class="wabident-info">Fecha Retirada</label>
      </div>
    </div>

    <!-- DATA -->
    <div class="form-group row">
      <div class="col-md-3">
        <wabident-dropdown name="show_arch_caliper" v-model="caliper"
          :options="arch_options.caliper"></wabident-dropdown>
        <label for="show_arch_caliper" class="wabident-info">Calibre</label>
      </div>

      <div class="col-md-3">
        <wabident-dropdown name="show_arch_material" v-model="material"
          :options="arch_options.material"></wabident-dropdown>
        <label for="show_arch_material" class="wabident-info">Material</label>
      </div>

      <div class="col-md-3">
        <wabident-dropdown name="show_arch_type" v-model="type" :options="arch_options.type">
        </wabident-dropdown>
        <label for="show_arch_type" class="wabident-info">Tipo</label>
      </div>

      <div class="col-md-3">
        <wabident-dropdown name="show_arch_number" v-model="number" :options="arch_options.number"></wabident-dropdown>
        <label for="show_arch_number" class="wabident-info">Número</label>
      </div>
    </div>

    <!-- NOTES -->
    <div class="form-group row">
      <div class="col">
        <textarea class="form-control" id="show_arch_notes" v-model="notes"
          placeholder="Escribe aquí Observaciones sobre el arco"></textarea>
        <label for="show_arch_notes" class="wabident-info">Observaciones</label>
      </div>
    </div>

    <div class="form-group row mt-5">
      <div class="col text-center">
        <button :disabled="is_loading" type="button" @click="onSubmit" class="btn btn-primary btn-wabident">
          <span v-if="is_loading">Guardando ...</span>
          <span v-else-if="is_editing">Modificar</span>
          <span v-else>Crear</span>
          <i v-if="is_loading" class="fas fa-circle-notch float-right"></i>
        </button>
      </div>
    </div>

  </b-modal>
</template>

<script>
export default {
  props: ['customer'],
  data() {
    return {
      is_loading: false,
      arch_id: null,
      placement_date: '',
      removal_date: '',
      arch: 'upper',
      caliper: '',
      material: '',
      type: '',
      number: '',
      notes: '',
      arch_options: {
        caliper: [],
        material: [],
        type: [],
        number: [],
      }
    }
  },
  computed: {
    is_editing() {
      return this.arch_id != null;
    },
    dialog_title() {
      return this.arch_id ? 'Editar Arco' : 'Crear Arco';
    },
    ...mapGetters(['clinic', 'msgwindow'])
  },
  methods: {
    loadArchOptions() {
      axios.get(`/clinic/${this.clinic.id}/arch_options`).then((response) => {
        this.arch_options = response.data;
      }).catch((err) => {
        this.msgwindow.error('Error cargando opciones de Elásticos. Contacta con el Administrador');
      });
    },
    onSubmit() {
      if (this.is_loading) {
        return true;
      }

      this.is_loading = true;

      let params = {
        placement_date: this.placement_date,
        removal_date: this.removal_date,
        arch: this.arch,
        caliper: this.caliper,
        material: this.material,
        type: this.type,
        number: this.number,
        notes: this.notes,
      };

      let uri = `/customer/${this.customer.id}/arches`;
      if (this.is_editing) {
        uri = `/customer/${this.customer.id}/arches/${this.arch_id}`;
        params['_method'] = 'patch';
      }

      axios.post(uri, params)
        .then((response) => {
          this.msgwindow.success('Arco guardado');
          this.$refs.modal.hide();
          this.$emit('submit');
        }).catch((error) => {
          this.msgwindow.error('Error guardando Arco. Contacta con el Administrador')
        }).then(() => {
          this.is_loading = false;
        });
    },
    showNew(arch = 'upper') {
      this.arch_id = null;
      this.placement_date = new Date().toISODate();
      this.removal_date = '';
      this.arch = arch;
      this.caliper = '';
      this.material = '';
      this.type = '';
      this.number = '';
      this.notes = '';

      this.$refs.modal.show();
    },
    showEdit(ortho_arch) {
      this.arch_id = ortho_arch.id;
      this.placement_date = ortho_arch.placement_date;
      this.removal_date = ortho_arch.removal_date;
      this.arch = ortho_arch.arch;
      this.caliper = ortho_arch.caliper;
      this.material = ortho_arch.material;
      this.type = ortho_arch.type;
      this.number = ortho_arch.number;
      this.notes = ortho_arch.notes;

      this.$refs.modal.show();
    }
  },
  mounted() {
    this.loadArchOptions();
  }
}
</script>

<style lang="scss">
#customer-show-ortho-arch {
  .modal-dialog {
    max-width: 40%;
  }
}
</style>
